import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
export function Badge({ tone, dot, pulse = false, children }) {
    return (_jsxs("span", { className: cx('badge', tone, pulse && 'pulse'), children: [_jsx("span", { className: "dot", style: dot ? { background: dot } : undefined }), children] }));
}
export function BadgeFromSpec({ spec }) {
    return (_jsx(Badge, { tone: spec.cls, dot: spec.dot, pulse: spec.pulse ?? false, children: spec.label }));
}
//# sourceMappingURL=Badge.js.map